$shm_hitalama_map_widget_float_iframe $shm_hitalama_map_widget_float
	auto /
		^
		<= pool_active null
	controls /
		^ iframe_content /
			<= Run $mol_button_major
				sub /
					<= Run_icon $mol_icon_play
				click? <=> run_click? null
			<= Iframe $shm_hitalama_map_widget_float_iframe_frame
				uri <= uri \
				html <= html null
				event_load? <=> iframe_on_load? null
				widget_link_str <= widget_link_str \
			<= Tg_post_dom $mol_view
				sub / ^ tg_post_script /
		^ blocker / <= Blocker $mol_view
	iframe_title? \
	- drag_body /
		<= Iframe_title $mol_paragraph
			title <= iframe_title? \

$shm_hitalama_map_widget_float_iframe_frame $mol_frame
	event *
		^
		load? <=> event_load? null
	attr *
		^
		data-crusref <= widget_link_str \
